import fetch from"./fetch";export default{info:{key:"javascript",title:"JavaScript",extname:".js",default:"fetch"},fetch:fetch};
//# sourceMappingURL=index.js.map